export const LANGUAGES: string[] = ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt', 'se', 'tr', 'zh'];
